var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9206 7.99983C15.9206 8.39747 15.5983 8.71979 15.2007 8.71979H2.53897L6.90976 13.0906C7.19094 13.3718 7.19094 13.8277 6.90976 14.1088C6.62859 14.39 6.17271 14.39 5.89152 14.1088L0.857305 9.07467C0.263711 8.48107 0.263711 7.51862 0.857305 6.92503L5.89153 1.89081C6.17271 1.60964 6.62859 1.60964 6.90976 1.89081C7.19094 2.17199 7.19094 2.62787 6.90976 2.90905L2.53898 7.27983H15.2007C15.5983 7.27983 15.9206 7.60218 15.9206 7.99983Z",
    fill: "#212737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.6fb18feac39d3fe3008975f7d67464d3.svg";
export { ForwardRef as ReactComponent };